import { render, staticRenderFns } from "./right-sidebar.vue?vue&type=template&id=7fc17597&"
import script from "./right-sidebar.vue?vue&type=script&lang=js&"
export * from "./right-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc17597')) {
      api.createRecord('7fc17597', component.options)
    } else {
      api.reload('7fc17597', component.options)
    }
    module.hot.accept("./right-sidebar.vue?vue&type=template&id=7fc17597&", function () {
      api.rerender('7fc17597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/right-sidebar.vue"
export default component.exports